import classes from '../css/PageSpinner.module.css';

const PageSpinner = () => (
  <div className={classes.Loader}>Loading...</div>
);

export default PageSpinner;
